// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable default-param-last, babel/camelcase */
import { Map, Record } from "immutable"
import type { Dispatch } from "redux"
import type { GetState } from "@kiwicom/frontend-common/services/types"
import Price from "@kiwicom/frontend-common/records/Price"
import { ERROR, INIT, LOADING, SUCCESS } from "@kiwicom/frontend-common/consts/phase"
import { MODALS } from "@kiwicom/frontend-common/consts/modals"
import type { PassengerId } from "@kiwicom/frontend-common/types/primitiveTypes"
import { bidSelector } from "@kiwicom/frontend-common/services/booking/booking"

import { openModalAction } from "../bookingActions"
import {
  US_INSURANCE_REFUND,
  US_INSURANCE_REFUND_REQUEST,
  US_INSURANCE_REFUND_FAILURE,
  US_INSURANCE_REFUND_SUCCESS,
  DESELECT,
  SELECT,
  SUBMIT_FAILURE,
  SUBMIT_REQUEST,
  SUBMIT_SUCCESS,
  TAB_CHANGE,
  NON_US_AXA_INSURANCE_REFUND,
  NON_US_AXA_INSURANCE_REFUND_FAILURE,
  NON_US_AXA_INSURANCE_REFUND_REQUEST,
  NON_US_AXA_INSURANCE_REFUND_SUCCESS,
} from "./consts"
import { postRefundByUUIDs } from "../../../../../../services/bookings/bookingsApi"
import { axaUsActivePaxInsurancesSelector } from "../../scenes/BookingAdditionalServices/scenes/InsuranceForm/services/bookingAxaUsInsuranceSelectors"
import type {
  AxaInsuranceAncillaries,
  AxaInsuranceLevel,
  AxaInsuranceAncillariesPassenger,
  AXASelectedOptionsRequest,
} from "../../scenes/BookingAncillary/consts/types"
import type { TabType } from "../../scenes/BookingAdditionalServices/scenes/InsuranceForm/types"
import { dataSelector } from "../../scenes/BookingAdditionalServices/scenes/InsuranceForm/services/bookingInsuranceSelectors"
import { axaAncillarySelector } from "../../scenes/BookingAncillary/services/BookingAncillaryDuck"
import { REDIRECT_TO_SHOPPING_BASKET_FAILURE } from "../../../../../../services/mmb2/types"

// @ts-expect-error: Flow to TS migration.
export const InitialState = new Record({
  // @ts-expect-error: Flow to TS migration.
  passengers: new Map({
    // @ts-expect-error: Flow to TS migration.
    tabType: new Map({
      // @ts-expect-error: Flow to TS migration.
      upgrade: new Map(),
      // @ts-expect-error: Flow to TS migration.
      downgrade: new Map(),
      // @ts-expect-error: Flow to TS migration.
      combo: new Map(),
    }),
  }),
  activeTabType: "upgrade",
  phase: INIT,
  error: null,
  usLoading: false,
  usError: undefined,
})

type Action = {
  type: string
  pid?: PassengerId
  insurance: AxaInsuranceLevel
  error: string
  tabType: TabType
}

export default function insuranceReducer(
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line no-undef
  state: InitialState | null | undefined = new InitialState(),
  raw: Action,
) {
  if (!(state instanceof InitialState)) return new InitialState(state)

  const action = raw
  if (action.pid) {
    // prevents key confusion - "1234" vs 1234
    action.pid = Number(action.pid)
  }

  switch (action.type) {
    case SELECT:
      return state.setIn(
        ["passengers", "tabType", state.get("activeTabType"), action.pid],
        action.insurance,
      )

    case DESELECT:
      return state.deleteIn(["passengers", "tabType", state.get("activeTabType"), action.pid])

    case TAB_CHANGE:
      return state.set("activeTabType", action.tabType)

    // submit
    // ---

    case NON_US_AXA_INSURANCE_REFUND_REQUEST:
    case SUBMIT_REQUEST:
      return state.set("phase", LOADING)

    case NON_US_AXA_INSURANCE_REFUND_SUCCESS:
    case SUBMIT_SUCCESS:
      return state.set("phase", SUCCESS)

    case SUBMIT_FAILURE:
    case NON_US_AXA_INSURANCE_REFUND_FAILURE:
    case REDIRECT_TO_SHOPPING_BASKET_FAILURE:
      return state.set("phase", ERROR).set("error", action.error)
    case US_INSURANCE_REFUND_REQUEST:
      return state.set("usLoading", true).set("usError", undefined)
    case US_INSURANCE_REFUND_FAILURE:
      return state.set("usLoading", false).set("usError", action.error)
    case US_INSURANCE_REFUND_SUCCESS:
      return state.set("usLoading", false)
    default:
      return state
  }
}

export const selectInsuranceAction = (pid: PassengerId, insurance: AxaInsuranceLevel) => ({
  type: SELECT,
  pid,
  insurance,
})

export const deselectInsuranceAction = (pid: PassengerId) => ({
  type: DESELECT,
  pid,
})

export const tabChangeAction = (tabType: TabType) => ({
  type: TAB_CHANGE,
  tabType,
})

const getActiveAxaInsuranceOrderItems: (
  arg1: AxaInsuranceAncillaries,
) => AxaInsuranceAncillariesPassenger[] = (axaInsuranceAncillaries) =>
  axaInsuranceAncillaries
    .map((insurance) => insurance.items)
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/array-type, @typescript-eslint/no-explicit-any
    .reduce<Array<any>>((acc, items) => acc.concat(items), [])
    .filter((insurnace) => insurnace.isActive)

const getRefundUUIDs = (
  selectedInsuranceRefunds: AXASelectedOptionsRequest[],
  ancillariesAxaOrders: AxaInsuranceAncillaries,
): string[] => {
  const passengerIdsForRefund = selectedInsuranceRefunds.map(
    (insuranceSelection) => insuranceSelection.passenger_id,
  )

  const activeAxaInsuranceOrderItems = getActiveAxaInsuranceOrderItems(ancillariesAxaOrders)

  const ordersForSelectedInsurances = activeAxaInsuranceOrderItems.filter((axaOrder) =>
    passengerIdsForRefund.includes(axaOrder.id),
  )

  return ordersForSelectedInsurances.map(
    (axaOrder: AxaInsuranceAncillariesPassenger) => axaOrder.universalId,
  )
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const refundAxaNonUsInsuranceAction = () => (dispatch: Dispatch<any>, getState: any) => {
  const state = getState()

  const bid = bidSelector(state)
  // dataSelector returns selection from the downgrade selections, because it's currently active tab
  const selectedInsuranceRefunds: AXASelectedOptionsRequest[] = dataSelector(state)
  const ancillariesAxaOrders: AxaInsuranceAncillaries = axaAncillarySelector(state)

  if (!selectedInsuranceRefunds.length || !ancillariesAxaOrders.length) {
    return
  }

  const refundUUIDs = getRefundUUIDs(selectedInsuranceRefunds, ancillariesAxaOrders)

  const payload = { universal_ids: refundUUIDs } as const
  const promise = postRefundByUUIDs(bid, payload)

  dispatch({
    type: NON_US_AXA_INSURANCE_REFUND,
    promise,
    _track: payload,
  })
}

export const refundAxaUsInsuranceAction = (price: Price) => async (
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>,
  getState: GetState,
) => {
  const state = getState()
  const bid = bidSelector(state)
  const activeAxaUsInsurances = axaUsActivePaxInsurancesSelector(state)

  const refund = {
    amount: price.amount.toString(),
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    currency: price.currency && price.currency.toUpperCase(),
  } as const

  // All active insurances will be refunded
  // @ts-expect-error: Flow to TS migration.
  const refundUUIDs = activeAxaUsInsurances.map((insurance) => insurance.universalId)

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/await-thenable
  const ok = await dispatch({
    type: US_INSURANCE_REFUND,
    promise: postRefundByUUIDs(bid, { universal_ids: refundUUIDs }),
    _track: { bid, refund, refundUUIDs },
  })
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  dispatch(openModalAction(ok ? MODALS.US_INSURANCE_SUCCESS : MODALS.US_INSURANCE_ERROR))
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const usInsuranceErrorSelector = (state: any) => state.bookingInsurance.usError
